module.exports = __webpack_public_path__ + "static/media/bg.40887f0d.png";